import { Action } from 'redux';
import { HttpErrorBaseAction, RemoteResource } from '../../types';

export interface ManagementReportEntry {
  date: string;
  total_stores_qty: number;
  stores_closed_ok_qty: number;
  unclosed_stores_qty: number;
  closed_stores_percentage: number;
  conciliated_coupons_percentage: number;
  conciliated_coupons_ok_qty: number;
  unconciliated_coupons_qty: number;
}

export interface ManagementReportFilters {
  countryCode: string;
  startDate: Date | null;
  endDate: Date | null;
}

export interface State {
  report: RemoteResource<ManagementReportEntry[]>;
  filters: ManagementReportFilters;
  appliedCountryCode: string;
}

export enum ActionType {
  managementReportRequested = 'management/reportRequested',
  managementReportSuccess = 'management/reportSuccess',
  managementReportFailure = 'management/reportFailure',
  managementChangeFilterCountry = 'management/changeFilterCountry',
  managementChangeFilterStartDate = 'management/changeFilterStartDate',
  managementChangeFilterEndDate = 'management/changeFilterEndDate',
}

export type ManagementReportRequestedAction = Action<ActionType.managementReportRequested>;

export type ManagementReportSuccessAction = Action<ActionType.managementReportSuccess> & {
  data: ManagementReportEntry[];
};

export type ManagementReportFailureAction = HttpErrorBaseAction<ActionType.managementReportFailure>;

export interface ManagementChangeFilterCountryAction
  extends Action<ActionType.managementChangeFilterCountry> {
  countryCode: string;
}

export interface ManagementChangeFilterDateAction
  extends Action<
    ActionType.managementChangeFilterStartDate | ActionType.managementChangeFilterEndDate
  > {
  date: Date | null;
}

export type Actions =
  | ManagementReportRequestedAction
  | ManagementReportSuccessAction
  | ManagementReportFailureAction
  | ManagementChangeFilterCountryAction
  | ManagementChangeFilterDateAction;
